import React, { Component } from 'react';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import './FrontPage.css';
import FullbleedHero from '../components/ContentBlocks/FullbleedHero';
import { fetchFront, fetchContact } from '../redux/actions';
import { connect } from 'react-redux';
import Loader from '../components/Loader';
import Helmet from 'react-helmet';
import './ContactPage.css';
import ReactMarkdown from 'react-markdown';

import ContentBlockHolder from '../components/ContentBlocks/ContentBlockHolder'
import ContentBlock from '../components/ContentBlocks/ContentBlock'

//import ContactForm from '../components/ContactForm';

import './OnePager.css'

class FrontPage extends Component {

  componentDidMount() {
    if (!this.props.headField||!this.props.liftField) {
      this.props.fetchFront(this.props.intl.locale, this.props.date);
    }
    if (!this.props.contact.header) {
      this.props.fetchContact(this.props.intl.locale);
    }
  }

  render() {
    return (
      <div className="front">
        <div>         
          <div className="outline-1" smooth-parallax="" end-position-y="-7" />
          <div className="outline-2" smooth-parallax="" end-position-y="-7" />
          <div className="outline-3" smooth-parallax="" end-position-y="-7" />
          <div className="outline-4" smooth-parallax="" end-position-y="-7" />
          <div className="outline-5" smooth-parallax="" end-position-y="-7" />

          <Helmet title="Goldfish" titleTemplate="%s" />
          {!this.props.headField && <Loader/>}
          {this.props.headField && <FullbleedHero fields={this.props.headField} />}
          {this.props.lifts &&
            <div className="front-lifts">
              <div className="container">
                <span className="fish" />
                <div>
                  {this.props.showLiftsHeading && <h3><FormattedMessage id="general.news" /></h3>}
                  <div>
                  {this.props.lifts.map((key, i) => {
                    //let date = new Date(key.sys.createdAt);
                    //let createdDate = date.getDate() + '.' + (date.getMonth()+1)+'.'+date.getFullYear();

                    return(
                      <div key={key.sys.id}>
                        {/*key.sys.createdAt && <time>{createdDate}</time>*/}
                        {key.fields.title && <h4>{key.fields.title}</h4>}
                        {key.fields.description && <ReactMarkdown source={key.fields.description} softBreak="br" />}
                        {(key.fields.link && key.fields.linkText) && <a href={key.fields.link} className="btn">{key.fields.linkText}</a>}
                      </div>
                    )
                  })}
                  </div>
                </div>
              </div>
            </div>
          }
          {this.props.containers &&
            this.props.containers.map((key, i) => {
              if(key.sys.contentType.sys.id==='container') {
                return (
                  <ContentBlockHolder key={key.sys.id}>
                    <ContentBlock align={key.fields.align ? key.fields.align.toLowerCase() : "center"} fields={key.fields} />
                  </ContentBlockHolder>
                )
              }
              return null;
            })
          }
          {this.props.contactPage &&
            <div className="contact" id="contact">
              {this.props.contact.header && <FullbleedHero fields={this.props.contact.header}/>}
              <div className="contact-body">
                <div className="container">
                {/*<div className="content-block center">
						<ContactForm />
						<p>&nbsp;</p><p>&nbsp;</p>
						{this.props.contact.leftColumn && <ReactMarkdown source={this.props.contact.leftColumn} softBreak="br" />}
					</div>
			  <div className="row">
                    <div id="open-hours" className="left-column">
                      <h2><FormattedMessage id="footer.openTitle" /></h2>
                      {this.props.contact.leftColumn && <ReactMarkdown source={this.props.contact.leftColumn} softBreak="br" />}
                    </div>
                    <div className="right-column">
                      <ContactForm />
                      {this.props.contact.rightColumn && <ReactMarkdown source={this.props.contact.rightColumn} softBreak="br" />}
                    </div>
                  </div>*/}
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
}

FrontPage.propTypes = {
  intl: intlShape.isRequired,
}

const mapStateToProps = state => ({
  headField:state.front.header,
  instagrams:state.instagrams,
  date:state.date,
  lifts:state.front.lifts,
  showLiftsHeading:state.front.showLiftsHeading,
  containers:state.front.containers,
  contactPage:state.front.contactPage,
  contact: state.contact,
});

const mapDispatchToProps = {
  fetchFront,
  fetchContact
};

export default connect(mapStateToProps,mapDispatchToProps)(injectIntl(FrontPage));



// WEBPACK FOOTER //
// ./src/containers/FrontPage.js